import React from "react";
import "../../styles/Tabella.css"

function TabellaOrariPreAgo() {
    return(
        <div className="table-container">
            <table className="table text-center m-auto" style={{width: "90%", maxWidth: "40em"}}>
                <thead>
                <tr>
                    <th className="" scope="col">Lun</th>
                    <th className="" scope="col">Mar</th>
                    <th className="" scope="col">Gio</th>
                    <th className="" scope="col">Ven</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th colSpan={4}  scope="" >Squadra B</th>
                </tr>
                <tr>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19:15</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19:15</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19:15</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19:15</td>
                </tr><tr>
                    <th colSpan={4}  scope="" >Squadra A</th>
                </tr>
                <tr>
                    <td className="data-cell">19:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 21:30</td>
                    <td className="data-cell">19:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 21:30</td>
                    <td className="data-cell">19:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 21:30</td>
                    <td className="data-cell">19:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 21:30</td>
                </tr>

                </tbody>
            </table>
        </div>
    )
}

export default TabellaOrariPreAgo